module.exports = __webpack_public_path__ + "static/media/history.4e58025d.svg";